module.exports = __webpack_public_path__ + "static/media/cafe_v_salon_2.d6259ba5.png";